import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

import T from '../../../../SPRINTA/translate/T'

import PlaceHolder from '../../../atoms/PlaceHolder'
import ListScroll, { Item as ListItem } from '../../../molecules/ListScroll'
import Font from '../../../atoms/Font'

import style from './style.css'

export default class ListCategories extends Component {
    static propTypes = {
        token: PropTypes.string.isRequired
    }

    state = {
        categories: null
    }

    componentWillMount() {
        axios.get(`events/categories/${this.props.token}`)
        .then(resp => {
            this.setState({
                categories: resp
            })

            if(resp.length > 0) {
                this.props.handleLoaded(true)
            }
        })
    }



    render() {
        if(this.state.categories !== null && this.state.categories.length === 0)
        return <span />
        
        return (
            <div className={style.categories}>
                { this.state.categories === null && (
                    <div>
                        <PlaceHolder type='retangle'/>
                        <PlaceHolder type='retangle'/>
                        <PlaceHolder type='retangle'/>
                    </div>
                )}

                { this.state.categories !== null && (
                    <div>
                        <Font size='30' weight="100">{T.text('categories')}</Font>                      

                        <ListScroll>
                            { this.state.categories.map(category => (
                                <ListItem key={category.id}>
                                    <Font weight='bold' size='12'>
                                        {category.description}
                                    </Font>
                                    <br />
                                    <Font size={11}>
                                        {
                                            (category.type === 'group')
                                            ? T.txt('group')
                                            : (category.min_members === '2' && category.max_members === '2')
                                            ? T.txt('pair')
                                            : (category.min_members > 0 && category.max_members > 1)
                                            ? T.txt('teams')
                                            : (category.min_age !== '0' || category.max_age !== '200' || category.gender !== 'u')
                                            ? T.txt('athletes')
                                            : ''
                                        }
                                        {
                                            (category.min_age !== '0' && category.max_age !== '200')
                                            ? ` ${T.txt('categories_min_max_age', { min: category.min_age, max: category.max_age})}`
                                            : (category.min_age === '0' && category.max_age !== '200')
                                            ? ` ${T.txt('categories_max_age', { max: category.max_age})}`
                                            : (category.min_age !== '0' && category.max_age === '200')
                                            ? ` ${T.txt('categories_min_age', { min: category.min_age})}`
                                            : ''
                                        }
                                        {
                                            (category.gender !== 'u')
                                            ? ` ${T.txt('categories_gender', { gender: (category.gender === 'f' ? T.txt('female') : T.txt('male') ) })}`
                                            : ''
                                        }
                                        {
                                            (category.min_members > 0 && category.max_members > 1 && !(category.min_members === '2' && category.max_members === '2'))
                                            ? ` ${T.txt('categories_min_max_athletes', { min: category.min_members, max: category.max_members})}`
                                            : ''
                                        }
                                    </Font>
                                </ListItem>
                            )) }
                        </ListScroll>
                    </div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/templates/Event/ListCategories/index.js